import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IFeaturedArticlesStore,
} from '../../mobx-store/storeInterfaces/featuredArticlesStore';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  FeaturedArticlesStore,
} from '../../mobx-store/stores/featuredArticlesStore';
import FeaturedArticleNotificationModal from '../../components/modals/articlesNotificationModal';
import { ICountry } from '../../mobx-store/storeInterfaces/authInterface';
import { countriesIsoCodes } from '../../constants/countries';
import { stat } from 'fs';

interface IProps {
  featuredArticlesStore?: FeaturedArticlesStore;
  countryStore?: CountryStore;
  history?: any;
}

interface State {
  notify: boolean;
  currentElement: number;
  open: boolean;
  currentArticle: number;
}

@inject('featuredArticlesStore')
@inject('countryStore')
@observer
class LiveFeaturedArticles extends Component<IProps & RouteComponentProps, State> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  isEgypt: boolean;

  handleAgree: () => void = () => null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.title = translate('featuredArticlesPageTitle', {
    });
    this.state = {
      notify: false,
      currentElement: 0,
      open: false,
      currentArticle: 0,
    };
  }

  handleCloseModal = () => {
    this.setState({
      notify: false,
    });
  };

  handleSendNotification = (
    titleEn: string,
    bodyEn: string,
    titleAr: string,
    bodyAr: string,
    status: 'members' | 'nonmembers' | 'all',
    type: string,
    navigationItemType: string,
    ): Promise<void> => {
    return new Promise<void> ((res, rej) => {
      this.props.featuredArticlesStore!.sendNotification(
        this.state.currentElement,
        titleEn,
        bodyEn,
        titleAr,
        bodyAr,
        status,
        type,
        navigationItemType,
        this.state.currentArticle,
        this.props.countryStore!.managedCountries,
      )
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 8000, 'success');
          res();
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
          rej();
        });
      this.setState({
        notify: false,
      });
    })
  };

  disableStatus = (index: number) => !this.props.featuredArticlesStore!.featuredArticlesList[index].isActive;

  handleNotificationButtonCellClicked = (index: number, key: string) => {
    this.setState({
      notify: true,
      currentElement: this.props.featuredArticlesStore!.featuredArticlesList[index].featuredArticleId,
      currentArticle: this.props.featuredArticlesStore!.featuredArticlesList[index].article.articleId,
    });
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    if (!value) {
      this.handleAgree = () => {
        this.props.featuredArticlesStore!.updateFeaturedArticleStatus(value, index)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch((error: any) => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else {
      this.props.featuredArticlesStore!.updateFeaturedArticleStatus(true, index)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/featured-articles/${this.props.featuredArticlesStore!.featuredArticlesList[index].featuredArticleId}/edit`);
  };

  handelAdd = (): void => {
    const articlesLimit = 3;
    console.log((this.props.featuredArticlesStore as IFeaturedArticlesStore).featuredArticlesList.length);
    if ((this.props.featuredArticlesStore as IFeaturedArticlesStore).featuredArticlesList.length === articlesLimit) {
      SnackBarComponent.getInstance().openSnackbar(translate('featuredArticlesCannotAddMessage', {
      }), 8000, 'error');
    } else {
      this.props.history.push('/featured-articles/new');
    }
  };

  getAddFeatuerdArticleButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getFeaturedArticlesTableHeaders = () => [
    {
      title: translate('featuredArticlesTableTitleColumn', {
      }),
    },
    {
      title: translate('featuredArticlesTableStatusColumn', {
      }),
    },
    {
      title: translate('featuredArticlesTableNotificationColumn', {
      }),
    },
    {
      title: translate('featuredArticlesTableEditColumn', {
      }),
    },
  ];

  getFeaturedArticlesTableData = () => this.props.featuredArticlesStore!.featuredArticlesList
    .map((featuredArticle) => ({
      ...featuredArticle,
      titleEn: featuredArticle.titleEn ? featuredArticle.titleEn : featuredArticle.article.titleEn,
      edit: translate('featuredArticlesEditButton', {
      }),
      notification: translate('featuredArticlesTableNotificationColumn', {
      }),
    }));

  getFeaturedArticlesTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('FeaturedArticlesStatusActive', {
      }),
      inactiveLabel: translate('FeaturedArticlesStatusNotActive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'notification',
      onClick: this.handleNotificationButtonCellClicked,
      disabled: this.disableStatus,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  getTableData = () => {
    this.addButton = this.getAddFeatuerdArticleButton();
    this.tableHeader = this.getFeaturedArticlesTableHeaders();
    this.tableData = this.getFeaturedArticlesTableData();
    this.tableCellTypes = this.getFeaturedArticlesTableCellTypes();
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    this.getTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('noFeatuerdArticlesMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loading={this.props.featuredArticlesStore!.loading || this.props.countryStore!.isLoadingManagedCountries}
          loadingStatus={[
            this.props.featuredArticlesStore!.getFeaturedArticlesRequestStatus,
            this.props.countryStore!.getManagedCountriesRequestStatus
          ]}
        />
        <FeaturedArticleNotificationModal
          open={this.state.notify}
          handleSend={this.handleSendNotification}
          handleClose={this.handleCloseModal}
          countryStore={this.props.countryStore}
          isEgypt={this.isEgypt}
        />
        <AlertDialog
          title="News Announcements"
          content={translate('newsListListDeactivationWarning', {
          })}
          isOpen={this.state.open}
          agree={this.handleAgree}
          disAgree={this.handleClose}
          hasActions
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      featuredArticlesStore,
    } = this.props;
    await countryStore!.getUserManagedCountries();

    if (countryStore!.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }

    featuredArticlesStore!.getFeaturedArticles(countryStore!.managedCountries, 'published');
  }
}

export default withRouter(LiveFeaturedArticles);
